/**
 * Discount Session Tracker
 * 
 * Tracks session-based discounts applied via URL (e.g., BenefitHub15)
 * Automatically clears cart discount when the session expires
 * 
 * Flow:
 * 1. User visits discount URL → Shopify sets session cookie
 * 2. This script stores the discount code in localStorage
 * 3. When session ends, cookie is deleted by browser
 * 4. On next page load, script detects missing cookie but existing localStorage
 * 5. Script clears the discount from cart and refreshes
 */
(function() {
  var DISCOUNT_CODE = 'BenefitHub15';
  var STORAGE_KEY = '10x_discount_session';
  var COOKIE_NAME = 'discount_code';

  function getCookie(name) {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  function handleDiscountSession() {
    var discountCookie = getCookie(COOKIE_NAME);
    var storedDiscount = localStorage.getItem(STORAGE_KEY);

    // Case 1: Discount cookie exists and matches our tracked code
    if (discountCookie && discountCookie === DISCOUNT_CODE) {
      localStorage.setItem(STORAGE_KEY, DISCOUNT_CODE);
      return;
    }

    // Case 2: No cookie but we have stored flag - session ended
    if (!discountCookie && storedDiscount === DISCOUNT_CODE) {
      // Clear discount from cart and refresh
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: '' })
      })
      .then(function() {
        localStorage.removeItem(STORAGE_KEY);
        window.location.reload();
      })
      .catch(function(err) {
        console.error('Failed to clear discount:', err);
      });
    }
  }

  // Run immediately
  handleDiscountSession();
})();
